import {AxiosPost} from "../../services/AxiosWrapper";
import ServiceUrls from "../../constants/ServiceUrls";

const { DOCUMENTSTORE_SERVICE_URL } = ServiceUrls;

export const insertSearchItemToBridge = (trItemIds) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Miscellaneous/InsertSearchItemToBridge`,
    { trItemIds }
  );
};
